var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKurtzErsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 178.079,
    height: 24.362,
    viewBox: "0 0 178.079 24.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #002946;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        clip-rule: evenodd;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-6 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-7 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-9 {\r\n        clip-path: url(#clip-path-7);\r\n      }\r\n\r\n      .cls-10 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clip-path-11);\r\n      }\r\n\r\n      .cls-12 {\r\n        clip-path: url(#clip-path-13);\r\n      }\r\n\r\n      .cls-13 {\r\n        clip-path: url(#clip-path-15);\r\n      }\r\n\r\n      .cls-14 {\r\n        clip-path: url(#clip-path-17);\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clip-path-19);\r\n      }\r\n\r\n      .cls-16 {\r\n        clip-path: url(#clip-path-21);\r\n      }\r\n\r\n      .cls-17 {\r\n        clip-path: url(#clip-path-22);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #779ed0;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    className: "cls-1",
    d: "M221.422-38.467h-3.609l-4.347-7.07-1.641,1.625v5.444H208.6V-58.733h3.226V-47.5l5.3-5.416H220.9L215.652-47.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    className: "cls-2",
    d: "M0,6410H1440V-92H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    className: "cls-1",
    d: "M227.515-43.845c0,1.514.389,2.973,2.306,2.973a5.805,5.805,0,0,0,2.723-.743V-52.572h3.278v11.094l.972,2.422-2.833.633L232.9-39.606a12.379,12.379,0,0,1-3.778,1.157c-3.056,0-4.89-1.762-4.89-4.79v-9.333h3.278Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    className: "cls-1",
    d: "M248.572-50.259c-.305-.027-.555-.027-.8-.027-1.638,0-2.638.689-4,1.652v10.02h-3.278v-11.37l-.778-2.064,2.723-.743.973,1.707c1.028-.578,1.75-1.018,2.445-1.322a5.275,5.275,0,0,1,1.944-.468,4.035,4.035,0,0,1,.944.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    className: "cls-1",
    d: "M252.1-42.166V-50.4h-1.917v-2.175H252.1V-54.14l1.528-2.671h1.75v4.239H259.1V-50.4h-3.723v7.377c0,1.542.528,1.927,1.472,1.927a9.214,9.214,0,0,0,2.973-.661l.667,2.34a12.508,12.508,0,0,1-4.362.936c-2.528,0-4.028-1.293-4.028-3.688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    className: "cls-1",
    d: "M262.24-41.037l7.14-9.25H262.6v-2.257h10.5v2.037l-7.7,9.718h7.7v2.175H262.24Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    className: "cls-1",
    d: "M286.549-46.488h5.807c-.056-2.863-.889-3.744-2.89-3.744-2.028,0-2.889.826-2.917,3.744m9.2.441v1.514h-9.2c.084,1.872.25,3.579,2.834,3.579a9.689,9.689,0,0,0,4.556-1.459l1.028,2.2a12.452,12.452,0,0,1-5.612,1.734c-4.779,0-6.223-2.34-6.223-7.212,0-4.9,1.639-7.047,6.306-7.047,4.362,0,6.307,1.982,6.307,6.69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    className: "cls-1",
    d: "M307.469-50.259c-.305-.027-.556-.027-.806-.027-1.639,0-2.639.689-4,1.652v10.02h-3.279v-11.37l-.777-2.064,2.722-.743.972,1.707c1.028-.578,1.751-1.018,2.445-1.322a5.279,5.279,0,0,1,1.945-.468,4.041,4.041,0,0,1,.945.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    className: "cls-1",
    d: "M308.469-40.156l1.305-2.147a10.509,10.509,0,0,0,4.862,1.514c1.334,0,2.751-.716,2.751-2.065,0-.908-1.111-1.321-2.084-1.6-3.695-1.046-5.945-1.734-5.945-4.46,0-2.7,2.084-3.8,5.112-3.8a18.735,18.735,0,0,1,5.779,1.046l-.722,2.258a14.774,14.774,0,0,0-4.7-1.019c-1.222,0-2.278.468-2.278,1.4,0,1.266,2.667,1.679,3.667,1.954,3,.826,4.473,1.569,4.473,4.1,0,2.615-2.112,4.515-6,4.515a12.991,12.991,0,0,1-6.223-1.707"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    className: "cls-1",
    d: "M328.249-45.056c-1.917,0-2.361,1.046-2.361,2.092,0,.963.556,2.12,2.667,2.12a6.246,6.246,0,0,0,2.751-.77v-3.441Zm3.417,5.45a13.312,13.312,0,0,1-3.611,1.157c-3.307,0-5.2-1.707-5.2-4.487,0-2.285,1.279-4.129,4.834-4.129h3.612v-1.4c0-1.211-.584-1.872-2.251-1.872a12.424,12.424,0,0,0-4.362,1.156l-.889-2.23a16.154,16.154,0,0,1,5.418-1.321c3.473,0,5.362.991,5.362,4.57v6.689l.972,2.423-2.834.633Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    className: "cls-1",
    d: "M179.658-45.089q-1.011-1.051-2.052-2.083-1.91-1.893-3.884-3.681c-1.415,1.274-2.824,2.6-4.191,3.957q-4.011,3.974-7.557,8.222l-.01.009L157.477-42.3q3.713-4.49,7.941-8.686,4.044-4.008,8.372-7.547l.008-.011q4.15,3.423,8.048,7.282,1.042,1.032,2.053,2.084Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    className: "cls-3",
    d: "M169.974-43.749q1.015,1.057,2.063,2.094,3.9,3.859,8.052,7.284l0,0q4.326-3.543,8.381-7.555,4.23-4.191,7.941-8.685l-.007-.007-4.462-3.813.017.014q-3.592,4.312-7.665,8.353-2.082,2.065-4.243,4l.053-.048q-1.974-1.789-3.886-3.682-1.065-1.056-2.1-2.131Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    className: "cls-4",
    d: "M0,6410H1440V-92H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Color",
    "data-name": "Logo Color",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1522",
    "data-name": "Gruppe 1522",
    className: "cls-5",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1521",
    "data-name": "Gruppe 1521",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    className: "cls-2",
    d: "M207.6-59.733h14.824v22.267H207.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1524",
    "data-name": "Gruppe 1524",
    className: "cls-7",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1523",
    "data-name": "Gruppe 1523",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    className: "cls-2",
    d: "M223.236-53.572h14.557v16.15H223.236Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1526",
    "data-name": "Gruppe 1526",
    className: "cls-8",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1525",
    "data-name": "Gruppe 1525",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    className: "cls-2",
    d: "M238.711-53.875h11.028v16.26H238.711Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1528",
    "data-name": "Gruppe 1528",
    className: "cls-9",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1527",
    "data-name": "Gruppe 1527",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    className: "cls-2",
    d: "M249.183-57.811H261.49v20.334H249.183Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1530",
    "data-name": "Gruppe 1530",
    className: "cls-10",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1529",
    "data-name": "Gruppe 1529",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    className: "cls-2",
    d: "M261.24-53.544H274.1v15.93H261.24Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1532",
    "data-name": "Gruppe 1532",
    className: "cls-11",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1531",
    "data-name": "Gruppe 1531",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    className: "cls-2",
    d: "M282.132-53.737h14.613v16.26H282.132Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1534",
    "data-name": "Gruppe 1534",
    className: "cls-12",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1533",
    "data-name": "Gruppe 1533",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    className: "cls-2",
    d: "M297.606-53.875h11.029v16.26H297.606Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1536",
    "data-name": "Gruppe 1536",
    className: "cls-13",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1535",
    "data-name": "Gruppe 1535",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    className: "cls-2",
    d: "M307.469-53.709h14.224v16.26H307.469Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1538",
    "data-name": "Gruppe 1538",
    className: "cls-14",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1537",
    "data-name": "Gruppe 1537",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    className: "cls-2",
    d: "M321.859-53.737h14.7v16.315h-14.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1540",
    "data-name": "Gruppe 1540",
    className: "cls-15",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1539",
    "data-name": "Gruppe 1539",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    "data-name": "Pfad 34",
    className: "cls-2",
    d: "M156.477-59.54H184.9v21.875H156.477Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1542",
    "data-name": "Gruppe 1542",
    className: "cls-16",
    transform: "translate(-157.477 58.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1541",
    "data-name": "Gruppe 1541",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    className: "cls-18",
    d: "M168.974-55.435h28.433v22.064H168.974Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurtzErsa);
export default __webpack_public_path__ + "static/media/kurtz-ersa.ad6eb49bf133a7e665e2981d1653cc18.svg";
export { ForwardRef as ReactComponent };